<template>
  <div class="login">
    <div class="content">
      <h3 style="color: green;">采销中心</h3>

      <!-- 登录表单 -->
      <el-form
        v-if="!isRegister"
        :model="loginForm"
        status-icon
        :rules="loginRules"
        ref="loginFormRef"
        class="demo-ruleForm"
      >
        <el-form-item prop="username">
          <el-input
            type="text"
            v-model="loginForm.username"
            prefix-icon="el-icon-user"
            placeholder="请输入手机号"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="loginForm.password"
            prefix-icon="el-icon-lock"
            placeholder="请输入密码"
          />
        </el-form-item>
        <el-form-item prop="captcha">
          <div class="captcha-wrapper">
            <el-input
              v-model="loginForm.captcha"
              prefix-icon="el-icon-key"
              placeholder="请输入验证码"
              class="captcha-input"
            />
            <div class="captcha-image" @click="refreshCaptcha">
              <img :src="captchaUrl" alt="验证码" v-if="captchaUrl" />
              <span v-else>加载中...</span>
            </div>
          </div>
        </el-form-item>
        <!-- 用户类型选择 -->
        <el-form-item prop="user_type">
          <el-radio-group v-model="loginForm.user_type">
            <el-radio label="wholesaler" border size="medium">品牌方</el-radio>
            <el-radio label="retailer" border size="medium">经销商</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="">
          <el-checkbox v-model="checked">记住我</el-checkbox>
        </el-form-item>
        <el-button type="primary" @click="handleLogin" :loading="loading">登录</el-button>
        <div class="bottom-links">
          <span class="link" @click="toggleRegister">暂未账号？前往注册账号</span>
          <span class="link" @click="forgotPassword">忘记密码</span>
        </div>
      </el-form>

      <!-- 注册表单 -->
      <el-form
        v-else
        :model="registerForm"
        status-icon
        :rules="registerRules"
        ref="registerFormRef"
        class="demo-ruleForm"
      >
        <el-form-item prop="username">
          <el-input
            type="text"
            v-model="registerForm.username"
            prefix-icon="el-icon-user"
            placeholder="请输入手机号"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="registerForm.password"
            prefix-icon="el-icon-lock"
            placeholder="请输入密码"
          />
        </el-form-item>
        <el-form-item prop="confirmPassword">
          <el-input
            type="password"
            v-model="registerForm.confirmPassword"
            prefix-icon="el-icon-lock"
            placeholder="请再次输入密码"
          />
        </el-form-item>
        <el-form-item prop="captcha">
          <div class="captcha-wrapper">
            <el-input
              v-model="registerForm.captcha"
              prefix-icon="el-icon-key"
              placeholder="请输入验证码"
              class="captcha-input"
            />
            <div class="captcha-image" @click="refreshCaptcha">
              <img :src="captchaUrl" alt="验证码" v-if="captchaUrl" />
              <span v-else>加载中...</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="comname">
          <el-input
            v-model="registerForm.comname"
            prefix-icon="el-icon-office-building"
            placeholder="请输入公司名称"
          />
        </el-form-item>
        <el-form-item prop="comcode">
          <el-input
            v-model="registerForm.comcode"
            prefix-icon="el-icon-document"
            placeholder="请输入统一社会信用代码"
          />
        </el-form-item>
        <el-form-item prop="user_type">
          <el-radio-group v-model="registerForm.user_type">
            <el-radio label="wholesaler" border size="medium">品牌方</el-radio>
            <el-radio label="retailer" border size="medium">经销商</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-button type="primary" @click="handleRegister" :loading="loading">注册</el-button>
        <div class="bottom-links">
          <span class="link" @click="toggleRegister">返回登录</span>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import axios from 'axios'

const captchaRequest = axios.create({
  withCredentials: true,
  responseType: 'arraybuffer'
})

const apiRequest = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

export default {
  name: 'Login',
  data () {
    // 手机号校验函数（仅用于规则，不触发自动校验）
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确'))
      } else {
        callback()
      }
    }
    // 确认密码校验
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.registerForm.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      isRegister: false,
      loginForm: {
        username: '',
        password: '',
        captcha: '',
        user_type: 'wholesaler'
      },
      registerForm: {
        username: '',
        password: '',
        confirmPassword: '',
        captcha: '',
        comname: '',
        comcode: '',
        user_type: 'wholesaler'
      },
      checked: false,
      loading: false,
      captchaUrl: '',
      serverCaptcha: '',
      // 登录校验规则（无 trigger，只在提交时校验）
      loginRules: {
        username: [
          { required: true, validator: validatePhone }
        ],
        password: [
          { required: true, message: '请输入密码' }
        ],
        captcha: [
          { required: true, message: '请输入验证码' }
        ],
        user_type: [
          { required: true, message: '请选择用户类型' }
        ]
      },
      // 注册校验规则（无 trigger）
      registerRules: {
        username: [
          { required: true, validator: validatePhone }
        ],
        password: [
          { required: true, message: '请输入密码' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPassword }
        ],
        captcha: [
          { required: true, message: '请输入验证码' }
        ],
        comname: [
          { required: true, message: '请输入公司名称' }
        ],
        comcode: [
          { required: true, message: '请输入统一社会信用代码' }
        ],
        user_type: [
          { required: true, message: '请选择用户类型' }
        ]
      }
    }
  },
  mounted () {
    if (Cookie.get('checked') === 'true') {
      this.checked = true
      this.loginForm.username = Cookie.get('username') || ''
      this.loginForm.password = Cookie.get('password') || ''
      const savedUserType = Cookie.get('user_type')
      if (savedUserType) {
        this.loginForm.user_type = savedUserType
      }
    }
    this.refreshCaptcha()
  },
  methods: {
    // 刷新图形验证码
    async refreshCaptcha () {
      try {
        const res = await captchaRequest.get('https://caixiao.lianglianyn.com/index/get_captcha.php', {
          params: { t: Date.now() }
        })
        console.log(res)
        // 从响应头获取服务端验证码文本（用于后端校验）
        const verifyCode = res.headers['x-verify-code'] || res.headers['X-Verify-Code']
        console.log(verifyCode)
        if (verifyCode) {
          this.serverCaptcha = verifyCode
        } else {
          console.warn('未获取到验证码标识')
        }
        // 将二进制图片转为 base64
        const base64 = btoa(
          new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
        )
        this.captchaUrl = `data:image/png;base64,${base64}`
      } catch (error) {
        console.error('获取验证码失败', error)
        this.$message.error('验证码加载失败，请刷新重试')
      }
    },

    toggleRegister () {
      this.isRegister = !this.isRegister
      // 清空校验状态（不触发校验）
      // if (this.$refs.loginFormRef) {
      //   this.$refs.loginFormRef.resetFields()
      //   this.$refs.loginFormRef.clearValidate()
      //   this.$refs.registerFormRef.resetFields()
      //   this.$refs.registerFormRef.clearValidate()
      // }
      // if (this.$refs.registerFormRef) {
      this.$refs.loginFormRef.resetFields()
      this.$refs.loginFormRef.clearValidate()
      this.$refs.registerFormRef.resetFields()
      this.$refs.registerFormRef.clearValidate()
      // }
      this.loginForm.captcha = ''
      this.registerForm.captcha = ''
      this.refreshCaptcha()
    },
    forgotPassword () {
      this.$message.info('请联系管理员重置密码')
    },
    handleLogin () {
      this.$refs.loginFormRef.validate(async (valid) => {
        if (!valid) return
        this.loading = true
        try {
          const response = await apiRequest.post(
            'https://caixiao.lianglianyn.com/index/login.php',
            {
              username: this.loginForm.username,
              password: this.loginForm.password,
              captcha: this.loginForm.captcha,
              ser_captcha: this.serverCaptcha || this.loginForm.captcha,
              user_type: this.loginForm.user_type
            }
          )
          const res = response.data
          if (res.code === 0) {
            if (this.checked) {
              Cookie.set('username', this.loginForm.username, { expires: 7 })
              Cookie.set('password', this.loginForm.password, { expires: 7 })
              Cookie.set('checked', 'true', { expires: 7 })
              Cookie.set('user_type', this.loginForm.user_type, { expires: 7 })
            } else {
              Cookie.remove('username')
              Cookie.remove('password')
              Cookie.remove('checked')
              Cookie.remove('user_type')
            }
            const { token, userid, user_fenlei: userFenlei, work_id: workId, sh_id: shId, jx_id: jxId, brand_id: brandId } = res.data
            localStorage.setItem('token', token)
            localStorage.setItem('user_name', res.data.username || this.loginForm.username)
            localStorage.setItem('user_type', this.loginForm.user_type || this.registerForm.user_type)
            Cookie.set('token', token, { expires: 3 })
            if (userid) localStorage.setItem('user_id', userid)
            if (jxId) localStorage.setItem('jx_id', jxId)
            if (shId) { localStorage.setItem('sh_id', shId) } else { localStorage.setItem('sh_id', -1) }
            if (this.loginForm.user_type === 'retailer')localStorage.setItem('jx_id', shId)
            if (brandId)localStorage.setItem('brand_id', brandId)
            if (userFenlei) localStorage.setItem('user_fenlei', userFenlei)
            if (workId) localStorage.setItem('work_id', workId)

            this.$message.success('登录成功')
            const redirect = this.$route.query.redirect || '/'
            this.$router.push(redirect)
          } else {
            this.$message.error(res.msg || '登录失败，请检查账号或验证码')
            this.refreshCaptcha()
            this.loginForm.captcha = ''
          }
        } catch (error) {
          console.error('登录异常', error)
          this.$message.error('网络错误，请稍后重试')
          this.refreshCaptcha()
          this.loginForm.captcha = ''
        } finally {
          this.loading = false
        }
      })
    },
    handleRegister () {
      this.$refs.registerFormRef.validate(async (valid) => {
        if (!valid) return
        this.loading = true
        try {
          const response = await apiRequest.post(
            'https://caixiao.lianglianyn.com/index/register.php',
            {
              a: 'password',
              username: this.registerForm.username,
              password: this.registerForm.password,
              captcha: this.registerForm.captcha,
              ser_captcha: this.serverCaptcha || this.registerForm.captcha,
              comname: this.registerForm.comname,
              comcode: this.registerForm.comcode,
              user_type: this.registerForm.user_type
            }
          )
          const res = response.data
          if (res.code === 0) {
            this.$message.success('注册成功，请登录')
            this.isRegister = false
            this.loginForm.username = this.registerForm.username
            this.loginForm.password = this.registerForm.password
            this.loginForm.user_type = this.registerForm.user_type
            this.loginForm.captcha = ''
            this.registerForm.captcha = ''
            this.registerForm.confirmPassword = ''
            // 切换后清空校验状态
            this.$refs.registerFormRef.resetFields()
            this.$refs.registerFormRef.clearValidate()
            this.refreshCaptcha()
          } else {
            this.$message.error(res.msg || '注册失败，请重试')
            this.refreshCaptcha()
            this.registerForm.captcha = ''
          }
        } catch (error) {
          console.error('注册异常', error)
          this.$message.error('网络错误，请稍后重试')
          this.refreshCaptcha()
          this.registerForm.captcha = ''
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  height: 100%;
  background: url("https://lianglianyn.com/xfdx/image/one/01.jpg") no-repeat center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
}
.content {
  border-radius: 6px;
  background: rgba(255,255,255,0.95);
  width: 420px;
  padding: 30px 30px 20px 30px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  h3 {
    text-align: center;
    font-size: 24px;
    margin-bottom: 20px;
    color: red;
  }
}
.el-form-item {
  margin-top: 20px;
}
.el-button--primary {
  width: 100%;
  margin-bottom: 10px;
}
.captcha-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  .captcha-input {
    flex: 1;
  }
  .captcha-image {
    height: 40px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f7fa;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
.bottom-links {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  .link {
    color: #409eff;
    cursor: pointer;
    font-size: 14px;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
